import ToasterProvider, { useToaster } from "./Toaster";

export default ToasterProvider;
export { useToaster };
